import React from 'react';
import { Truck } from 'lucide-react';
import './SharedBlocks.css';

export const RiskFreeBlock = ({ title = 'BUY RISK FREE', description = '24 HOURS TO EDIT OR CANCEL YOUR ORDER' }) => (
  <div className="pp__risk-free">
    <p className="pp__risk-free-title typo-h5">{title}</p>
    <p className="pp__risk-free-text typo-body-sm">{description}</p>
  </div>
);

export const DeliveryBlock = ({
  time = '3 Weeks',
  cost = 'Free',
  description = 'Delivery to your school',
  icon: Icon = Truck,
}) => (
  <div className="pp__delivery-mobile">
    <div className="pp__delivery-mobile-icon">
      <Icon size={20} strokeWidth={1.5} />
    </div>
    <div className="pp__delivery-mobile-text">
      <div className="pp__delivery-mobile-headline">
        <span className="pp__delivery-mobile-time typo-h5">{time}</span>
        {cost ? (
          <>
            <span className="pp__delivery-mobile-dot typo-label">{'\u2022'}</span>
            <span className="pp__delivery-mobile-cost typo-h5">{cost}</span>
          </>
        ) : null}
      </div>
      {description ? <span className="pp__delivery-mobile-desc typo-body-sm">{description}</span> : null}
    </div>
  </div>
);
